import { LAYOUT_EXPANDABLE, ALERT_SHOW, ALERT_HIDE, RESET_LAYOUT, SET_FLASH } from './actionTypes';
export var expandElement = function (name) { return ({
    type: LAYOUT_EXPANDABLE,
    name: name,
    value: true
}); };
export var collapseElement = function (name) { return ({
    type: LAYOUT_EXPANDABLE,
    name: name,
    value: false
}); };
export var showAlert = function (name) { return ({
    type: ALERT_SHOW,
    name: name
}); };
export var hideAlert = function (name) { return ({
    type: ALERT_HIDE,
    name: name
}); };
export var resetLayout = function () { return ({
    type: RESET_LAYOUT,
}); };
export var setFlash = function (flash) { return ({
    type: SET_FLASH,
    flash: flash
}); };
